export function roomSingle(state = { roomSingle: false }, action) {
  if (state.selectedRoomtype && state.selectedRoomtype[state.selectedRoomtype.length - 1]) {
    state = {
      ...state,
      roomSingle: state.selectedRoomtype[state.selectedRoomtype.length - 1] == 1,
    };
  }

  return state;
}
